import type { Law } from "../types";

export const mereExposureEffect: Law = {
  slug: "mere-exposure-effect",
  title: "Mere-Exposure Effect",
  definition: "Repeated exposure to a stimulus increases liking for it, even without conscious awareness of the exposure.",
  category: "psychology",
  color: "#68d391",
  labels: ["psychology", "design", "product"],
  copy: [
    "The mere-exposure effect is the finding that familiarity breeds fondness: people rate stimuli they have seen before more positively, independent of any reasoned judgment about them.",
    "It explains why brands repeat, why first impressions compound, and why a design that is merely consistent and familiar can outperform one that is novel — and why the first experience with a product sets the reference for everything after.",
  ],
  sources: ["https://en.wikipedia.org/wiki/Mere-exposure_effect"],
  related: ["halo-effect", "ikea-effect"],
};
